<div style="min-height: 200px" [nbSpinner]="loading">
    <app-shared-filter [filter]="filters" (onChange)="onFilterChange($event)"></app-shared-filter>

    <ng-container *ngIf="matches">
        <nb-card
            *ngFor="let match of matches | slice : (page - 1) * perPage : (page - 1) * perPage + perPage"
            class="card-match"
        >
            <nb-card-header>
                <div class="match-participants">
                    <div class="match-participants__group">
                        <div
                            class="match-participant"
                            *ngFor="let participant of match.participantGroup[0]?.participants"
                        >
                            <div class="match-participant__img">
                                <img [src]="participant.url_avatar" [alt]="participant.nome" width="72" height="72" />
                            </div>
                            <p class="match-participant__name">
                                {{ participant.nome }}
                            </p>
                        </div>
                    </div>
                    <span class="match-participant__result" *ngIf="match?.resultado?.['1']">
                        {{ match.resultado?.["1"] }}
                    </span>
                    <div class="participant__vs">vs</div>
                    <span class="match-participant__result" *ngIf="match?.resultado?.['2']">
                        {{ match.resultado?.["2"] }}
                    </span>
                    <div class="match-participants__group">
                        <div
                            class="match-participant"
                            *ngFor="let participant of match.participantGroup[1]?.participants"
                        >
                            <div class="match-participant__img">
                                <img [src]="participant.url_avatar" [alt]="participant.nome" width="62" height="62" />
                            </div>
                            <p class="match-participant__name">
                                {{ participant.nome }}
                            </p>
                        </div>
                    </div>
                </div>
            </nb-card-header>
            <nb-card-body>
                <nb-list>
                    <nb-list-item (click)="onMatchClick(match)">
                        <span>Detalhes do confronto</span>
                        <button nbButton outline status="primary" size="tiny">
                            Visualizar
                            <nb-icon icon="diagonal-arrow-right-up-outline"></nb-icon>
                        </button>
                    </nb-list-item>
                    <nb-list-item>
                        <span>{{ "GENERAL.CATEGORIES" | translate }}</span>
                        <span>{{ match.geral.nome_categoria }}</span>
                    </nb-list-item>
                    <nb-list-item>
                        <span>{{ "GENERAL.LOCAL" | translate }}</span>
                        <span *ngIf="match.local">{{ match.local.nome_local }}</span>
                    </nb-list-item>
                    <nb-list-item>
                        <span>{{ "CONTACT-PAGE.ADDRESS" | translate }}</span>
                        <span *ngIf="match.local">{{ match.local.endereco }}</span>
                    </nb-list-item>
                    <nb-list-item>
                        <span>{{ "GENERAL.COURT" | translate }}</span>
                        <span *ngIf="match.quadra">{{ match.quadra?.descricao || "-" }}</span>
                    </nb-list-item>
                    <nb-list-item>
                        <span>{{ "GAME.GAME-DATE" | translate }}</span>
                        <span *ngIf="match.dt_jogo">{{ match.dt_jogo + ", " + match.hr_jogo }}</span>
                    </nb-list-item>
                </nb-list>
            </nb-card-body>
        </nb-card>

        <div class="col-lg-12">
            <app-shared-pagination
                [perPage]="perPage"
                [size]="matches.length"
                (onChange)="page = $event"
            ></app-shared-pagination>
        </div>
    </ng-container>
    <ng-container *ngIf="!matches && !loading">
        <h2 class="not-found">
            Ops!
            <br />
            <span>{{ "MESSAGE.RESULT.TRANSACTION-WITHOUT-RETURN" | translate }}</span>
        </h2>
    </ng-container>
</div>
